import { c as _c } from "react/compiler-runtime";
import { Modal, ModalContent, ModalHeader, ModalBody, Progress, Link } from "@heroui/react";
import { useIsPremium } from "@/hooks/useIsPremium";
import { useConnection } from "wagmi";
import { cn } from "@/util/cn";
import { Info } from "lucide-react";
import PremiumGem from "@/components/Image/Svg/PremiumGem";
import ChewyHead from "@/components/Image/Svg/ChewyHead";
import CryptoHolderTier from "../Common/CryptoHolderTier";
interface ChewyBalanceModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}
export default function ChewyBalanceModal(t0) {
  const $ = _c(9);
  const {
    isOpen,
    onOpenChange
  } = t0;
  const {
    address
  } = useConnection();
  const {
    balance,
    isPremium,
    premPercentage
  } = useIsPremium(address);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("cards-modal");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== balance || $[2] !== isPremium || $[3] !== premPercentage) {
    t2 = <ModalContent>{onClose => <><ModalHeader className="flex flex-col gap-1"><div className="inline-block"><ChewyHead className="inline-block mr-1 w-[25px] h-[25px]" />Your CHEWY Balance</div></ModalHeader><ModalBody className="px-6 py-4"><div className="flex flex-col gap-4"><div className="flex flex-col gap-2">{balance?.total && balance.total > 0 ? <><div className="text-lg font-bold">Total: {isPremium && <>{" "}<PremiumGem className="inline-block self-center w-[20px] h-[20px]" /></>} {balance?.total.toLocaleString()} CHEWY</div><div className="text-sm text-gray-400">Shibarium: {balance?.shibarium.toLocaleString()} CHEWY</div>{balance?.shibariumLp && balance.shibariumLp > 0 ? <div className="text-sm text-gray-400">Staked Chewy-BONE LP: {balance.shibariumLp.toLocaleString()} CHEWY</div> : ""}<div className="text-sm text-gray-400">Dogechain: {balance?.doge.toLocaleString()} CHEWY</div>{balance?.dogeLp && balance?.dogeLp > 0 ? <div className="text-sm text-gray-400">Staked Chewy-DC LP: {balance?.dogeLp.toLocaleString()} CHEWY</div> : ""}</> : <div className="flex justify-center text-lg">No CHEWY Held or Staked in this Wallet!</div>}</div><div className="flex flex-col gap-2 mt-2">{!isPremium && <><div className="flex items-center gap-2"><Info size={16} /><span className="text-sm">Premium Status Progress</span></div><Progress value={premPercentage} color={isPremium ? "success" : "warning"} className="w-full" /></>}<div className="text-sm text-center">{isPremium ? <><PremiumGem className="inline-block self-center mr-2 w-[20px] h-[20px]" />Enjoy your premium CHEWY holder perks!</> : <>Hold {(6900 - (balance?.total || 0)).toLocaleString()} more CHEWY to unlock Premium!<div className="mt-2"><Link href="https://chewyswap.dog/swap" target="_blank" rel="noopener noreferrer" className="text-primary">Buy CHEWY</Link></div></>}</div></div></div></ModalBody></>}</ModalContent>;
    $[1] = balance;
    $[2] = isPremium;
    $[3] = premPercentage;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isOpen || $[6] !== onOpenChange || $[7] !== t2) {
    t3 = <Modal isOpen={isOpen} onOpenChange={onOpenChange} backdrop="blur" placement="center" className={t1}>{t2}</Modal>;
    $[5] = isOpen;
    $[6] = onOpenChange;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}